// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Arreglo estilos de react-datepicker que se llevan muy mal con bootstrap
   https://github.com/Hacker0x01/react-datepicker/issues/624#issuecomment-261696513
*/
.light {
  --color-blue: #0078d7;
}
.react-datepicker {
  font-size: 1em;
}
.react-datepicker-wrapper {
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
}
.react-datepicker-popper {
  z-index: 3;
}
.react-datepicker__input-container {
  display: block;
}
.react-datepicker__header {
  padding-top: 0.8em;
  background-color: #f7f9fa;
}
.react-datepicker__today-button {
  background-color: #fff;
  color: var(--color-blue);
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
.react-datepicker__tether-element-attached-top .react-datepicker__triangle {
  border-bottom-color: #f7f9fa;
}
.react-datepicker__month {
  margin: 0.4em 1em;
}
.react-datepicker__day-name,
.react-datepicker__day {
  width: 1.9em;
  line-height: 1.9em;
  margin: 0.166em;
}
.react-datepicker__day--selected {
  background-color: var(--color-blue);
  border-radius: 4px;
}
.react-datepicker__day--outside-month {
  color: #ccc;
}
.react-datepicker__current-month {
  font-size: 1em;
}
.react-datepicker__navigation {
  border: 0.45em solid transparent;
}
`, "",{"version":3,"sources":["webpack://./src/core/css/react-datepicker.less"],"names":[],"mappings":"AAAA;;CAEC;AACD;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC","sourcesContent":["/* Arreglo estilos de react-datepicker que se llevan muy mal con bootstrap\n   https://github.com/Hacker0x01/react-datepicker/issues/624#issuecomment-261696513\n*/\n.light {\n  --color-blue: #0078d7;\n}\n.react-datepicker {\n  font-size: 1em;\n}\n.react-datepicker-wrapper {\n  display: block;\n  width: 100%;\n  padding: 0;\n  border: 0;\n}\n.react-datepicker-popper {\n  z-index: 3;\n}\n.react-datepicker__input-container {\n  display: block;\n}\n.react-datepicker__header {\n  padding-top: 0.8em;\n  background-color: #f7f9fa;\n}\n.react-datepicker__today-button {\n  background-color: #fff;\n  color: var(--color-blue);\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n.react-datepicker__tether-element-attached-top .react-datepicker__triangle {\n  border-bottom-color: #f7f9fa;\n}\n.react-datepicker__month {\n  margin: 0.4em 1em;\n}\n.react-datepicker__day-name,\n.react-datepicker__day {\n  width: 1.9em;\n  line-height: 1.9em;\n  margin: 0.166em;\n}\n.react-datepicker__day--selected {\n  background-color: var(--color-blue);\n  border-radius: 4px;\n}\n.react-datepicker__day--outside-month {\n  color: #ccc;\n}\n.react-datepicker__current-month {\n  font-size: 1em;\n}\n.react-datepicker__navigation {\n  border: 0.45em solid transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
